import { RecordIcon } from './RecordIcon';
import type { IToolIconButtonProps } from './IToolIconButtonProps';

/** Іконкова кнопка панелі запису (прототип v4): 32×32, радіус 8, рамка --line2; наведення — тло --surface2 і акцентна іконка. */
export function ToolIconButton({ glyph, label, onClick, disabled, hint }: IToolIconButtonProps) {
  return (
    <button type="button" className="rec-ibtn" title={hint ?? label} aria-label={label} onClick={onClick} disabled={disabled}>
      <RecordIcon name={glyph} />
    </button>
  );
}
